import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import type TrailTraffic from '@alltrails/trails/types/TrailTraffic';

const visitationMessages = defineMessages<TrailTraffic>({
  light: { defaultMessage: 'Not very busy' },
  moderate: { defaultMessage: 'Somewhat busy' },
  heavy: { defaultMessage: 'Busy' }
});

export default function getVisitationLabel(intl: IntlShape, trailTraffic: TrailTraffic): string {
  const message = visitationMessages[trailTraffic];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown visitation (trail traffic): ${trailTraffic}`));
  return '';
}
